const terrains = {

        // view structure
        title: String("Fincas"),
        terrainsTableTitle: String("Gestión de mis fincas"),

        // Table headers
        terrainName: String("Nombre de la finca"),
        terrainAddressMunicipality: String("Municipio"),
        terrainHomogeneousGrowingArea: String("Zona homogénea de cultivo"),
        terrainCoordinates: String("Coordernadas"),
        terrainPlotActionHeader: String("Acciones"),

        // Buttons
        terrainNewTerrainButton: String("Crear nueva finca"),
        terrainPlotActionModify: String("Modificar"),
        terrainPlotActionDelete: String("Eliminar"),
        deletePromptModalTitle: String("Eliminar finca"),
        deleteModalBody: String("Estas apunto de eliminar una finca. Una vez eliminada sera imposible restaurarla. Seguro que quieres eliminarla?"),
        deleteModalAccept: String("Eliminar"),
        deleteModalRejec: String("Cancelar"),

};

export default terrains;